import { InfraCmtResponse } from "~/@shared/api-types/InfraCmtResponse"
import { defineFetcher } from "~/api/_common/defineFetcher"
import { POST } from "~/api/_common/http"

import { PostAuthRegisterBody } from "../register/post"

/**
 * 新規登録：追加情報の入力API
 * API @see: https://github.com/Traimmu/Infra/pull/4924
 * @desc Success: SuccessInfraResponse.dataの値は存在しない
 *       Fail: PostAuthRegisterBodyのkey毎のエラーを取得する
 */
export const fetchPostAuthRegisterAdditionally = defineFetcher(
  (body: PostAuthRegisterBody): Promise<InfraCmtResponse<PostAuthRegisterBody>> => {
    return POST("/auth/register-additionally", body)
  }
)
